/* ==========================================================================
   FreezeCap™ — fc-final-cta.liquid wiring (extracted from inline in v6.28)
   --------------------------------------------------------------------------
   Refrigerant-model toggle on the homepage final CTA. Updates the order
   button's href to point to the right variant when the user picks R-134a
   vs R-1234yf. Pure data-attribute driven — no Liquid interpolation.
   ========================================================================== */
(function () {
  function init() {
    var toggle = document.getElementById('fc-cta-model-toggle');
    var ctaBtn = document.getElementById('fc-cta-order-btn');
    if (!toggle) return;

    var productUrl = toggle.getAttribute('data-product-url') || '/products/freezecap';
    var variants = {
      r134a:   toggle.getAttribute('data-variant-r134a'),
      r1234yf: toggle.getAttribute('data-variant-r1234yf')
    };

    var btns = toggle.querySelectorAll('button');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (!ctaBtn) return;
        var model = btn.getAttribute('data-model');
        var vid   = variants[model];
        ctaBtn.setAttribute('href', productUrl + (vid ? '?variant=' + encodeURIComponent(vid) : ''));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
